module.exports = __webpack_public_path__ + "static/img/C4D0041.b0728c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/intru/C4D0041.jpg
// module id = y/rm
// module chunks = 0